<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-cloud-upload"></i> Import Hold Events from CSV Files
  </h5>
  <button (click)="onClose()"
          type="button"
          class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-csv-file-parser [columnDefs]="columnDefs"
                       [guide]="guide"
                       (parsed)="onCsvFilesParsed($event)"></app-csv-file-parser>
</div>
<div class="modal-footer">
  <button (click)="onClose()"
          type="button"
          class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="onCreate()"
          [disabled]="!files?.length || hasErrors()"
          type="button"
          class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-cloud-upload"></i> upload
  </button>
</div>
